var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import "@frameworks/salesjourney/stylesheets/components/Generic/SearchField.scss";
var _ = require("lodash");
var SearchField = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState(false), 2), isSearchFocused = _e[0], setIsSearchFocused = _e[1];
    var debounce = _.debounce(function (func) {
        func();
    }, 500);
    return (React.createElement("div", { className: (_a = props.parentClass) !== null && _a !== void 0 ? _a : "" },
        React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint bg_white ", type: "search", defaultValue: (_b = props === null || props === void 0 ? void 0 : props.searchText) !== null && _b !== void 0 ? _b : "", value: (_c = props === null || props === void 0 ? void 0 : props.searchText) !== null && _c !== void 0 ? _c : "", placeholder: (_d = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _d !== void 0 ? _d : "Search here ...", "aria-label": "Search", onChange: function (e) {
                // debounce(() => {
                props === null || props === void 0 ? void 0 : props.setSearchText(e.target.value);
                // });
            }, autoFocus: isSearchFocused, onFocus: function () { return setIsSearchFocused(true); } }),
        (props === null || props === void 0 ? void 0 : props.searchText) ? (React.createElement("span", { className: "edel-icon-close hand_cursor", onClick: function () {
                props === null || props === void 0 ? void 0 : props.setSearchText("");
                setIsSearchFocused(true);
            } })) : (React.createElement("i", { className: "edel-icon-search1" }))));
};
export default SearchField;
